// extracted by mini-css-extract-plugin
export default {"heading":"Rt-z","corrected":"St-z","redirectVerbiageContainer":"Tt-z","redirectVerbiageText":"Ut-z"};